import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    permissions: [],
    user: {},
    cart: [],
    token: '',
    loading: false,
    error: false,
    menuCollabsed: true
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER(state, user) {
      state.user = user
      if(user.roles != null){
        user.roles.forEach(element => {
          if(element.permissions != null){
            element.permissions.forEach(el => {
              state.permissions.push(el.name)
            });
          }
        });
      }else{
        state.permissions = []
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_MENU_COLLABSED(state, menuCollabsed) {
      state.menuCollabsed = menuCollabsed
    },
    CLEAR_CART(state){
      state.cart.length = 0;
    },
    ADD_TO_CART(state, product){
      state.cart.push(product)
    },
    REMOVE_FROM_CART(state, product){
      if(state.cart.indexOf(product)){
        state.cart.splice(state.cart.indexOf(product));
      }
    }
  },
  actions: {
     setUser(context, user){
       context.commit('SET_USER', user);
     },
    doLogin(context, { user, token }) {
      context.commit('SET_USER', user);
      context.commit('SET_TOKEN', token);
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    doLogout(context) {
      context.commit('SET_USER', []);
      context.commit('SET_TOKEN', '');
    },
    clearCart(context){
      context.commit('CLEAR_CART');
    },
    addToCart(context, product){
      console.log(product)
      context.commit('ADD_TO_CART',product);
    },
    removeFromCart(context, product){
      context.commit('REMOVE_FROM_CART',product);
    },
  },
  getters: {
    token(state) {
      return state.token
    },
    isLoggedIn(state) {
      return !(state.token === '')
    },
    isLoading(state) {
      return state.loading
    },
    isMenuCollabsed(state) {
      return state.menuCollabsed
    },
    isError(state) {
      return !(state.error === false)
    },
    currendUser(state) {
      return state.user
    },
    user(state){
      return state.user
    },
    userId(state) {
      return state.user.id
    },
    company(state) {
      return state.user.company
    },
    role(state) {
      return (state.user.roles && state.user.roles[0]) ? state.user.roles[0] : 'customer'
    },
    permissions(state) {
      return state.permissions;
    },
    error(state) {
      return state.error
    },
    cart(state){
      return state.cart
    },
  },
});
